import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { makeUserNameSelector } from "~/store/selectors/selector.users.jsx";

const UserName = ({ id, className, linkName }) => {
  const getName = useMemo(() => makeUserNameSelector(), []);
  const name = useSelector((state) => getName(state, id));

  return <div className={className}>{linkName ? <Link to={`/users/${id}`}>{name}</Link> : name}</div>;
};

UserName.propTypes = {
  className: PropTypes.string,
  linkName: PropTypes.bool,
  id: PropTypes.number,
};

UserName.defaultProps = {
  linkName: false,
};

export default UserName;
